import React, { useRef, useEffect, useState } from 'react';
import './RydFloatingPanel.css';


export function RydFloatingPanel({
    referenceElement,
    offsetX = 0,
    offsetY = 0,
    children
}: {
    referenceElement: HTMLElement,
    offsetX?: number,
    offsetY?: number,
    children: React.ReactNode
}) {
    const panelRef = useRef<HTMLDivElement>(null);
    const [position, setPosition] = useState({ top: 0, left: 0 });

    useEffect(() => {
        if (referenceElement && panelRef.current) {
            const rect = referenceElement.getBoundingClientRect();

            let top = rect.top + offsetY;
            let left = rect.left + offsetX;

            if (referenceElement.parentElement) {
                const parentRect = referenceElement.parentElement.getBoundingClientRect();
                top -= parentRect.top;
                left -= parentRect.left;
            }

            setPosition({
                top: top,
                left: left,
            });
        }
    }, [referenceElement, offsetX, offsetY]);

    /** I won't preted I came up with this. Source for later ref because I
     * won't understand: https://stackoverflow.com/questions/12013066/how-to-ignore-parent-elements-overflowhidden-in-css
     * The gist is that we need a wrapper div with relative position to reference
     * element, and the inner one with position fixed to break out of the stacking.
     *
    */
    return (
        <div className='ryd-floating-panel--wrapper'
            style={{
                top: `${position.top}px`,
                left: `${position.left}px`,
            }}>
            <div className='ryd-floating-panel'
                ref={panelRef}
            >
                {children}
            </div>
        </div>
    );
};